export default "https://legacy.eskolare-development.com/images/sellers.png";